export default {
    title: 'Innovation field name',
    macrotrends: 'Macro-trends',
    description: 'Description',
    contactPerson: 'Contact person',

    validation: {
        title: {
            required: 'Please add title of innovation field',
            length: 'The title should not contain more than 512 characters'
        },
        description: {
            length: 'The description should not be longer than 4000 characters'
        },
        image: {
            size: 'The image must not be larger than 8MB',
            mimetype: 'Please use GIF/JPG/PNG only'
        }
    },

    cancel: 'Cancel',
    submit: 'Submit',
    success: 'The innovation field was created successfully'
}
